import type {
  TemplateCreativeProps,
  TemplateCreativeXinglet,
} from '@xing-com/crate-lebenslauf-xinglets';

import { Creative } from './creative';

export default class TemplateCreative implements TemplateCreativeXinglet {
  public getComponent() {
    return (props: TemplateCreativeProps): JSX.Element => (
      <Creative {...props} />
    );
  }
}
